import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as Styled from "./layer-switch.style";
import { useAppDispatch, actions, useAppSelector, selectors } from "store";
import { DEFAULT_LAYER } from "store/layers";
import { Switch } from "ui/components/elements/switch";
/*
 * Switches which stacking layer of cardboard boxes is shown/edited. A real
 * de-palletizing stack alternates between two box arrangements; switching
 * swaps the visible boxes and the displayed calculation.
 *
 * A system has ONE layer until the user adds the second — nothing forces two.
 * "Add 2nd layer" starts the second layer as the first layer's pattern,
 * mirrored (the interlocking default; identical layers are what makes a stack
 * fall over), or as a copy of a hand-arranged first layer.
 * Removing it makes the system single-layer again; both are one undoable
 * step. Rendered at the top of the pallet-controls column, above the presets
 * (see `PalletPresetSwitch`): pick the layer, then how it is arranged.
 */
export var LayerSwitch = function () {
    var t = useTranslation().t;
    var dispatch = useAppDispatch();
    var activeLayer = useAppSelector(selectors.selectActiveLayer);
    var isSecondLayerInUse = useAppSelector(selectors.selectIsSecondLayerInUse);
    /* Undo (or loading another system) can take the second layer away while it
     * is the one on screen; fall back to the first layer rather than showing an
     * empty scene. */
    useEffect(function () {
        if (!isSecondLayerInUse && activeLayer !== DEFAULT_LAYER) {
            dispatch(actions.setActiveLayer(DEFAULT_LAYER));
        }
    }, [isSecondLayerInUse, activeLayer, dispatch]);
    return (_jsx(Styled.LayerSwitch, { children: isSecondLayerInUse ? (_jsxs(_Fragment, { children: [_jsx(Switch, { heading: t("layers.heading"), options: [
                        { label: t("layers.layer_1"), value: 0 },
                        { label: t("layers.layer_2"), value: 1 },
                    ], value: activeLayer, onValueChange: function (value) {
                        dispatch(actions.setActiveLayer(value));
                    } }), _jsx(Styled.LayerButton, { onClick: function () { return dispatch(actions.removeSecondLayer()); }, children: t("layers.remove_layer") })] })) : (_jsx(Styled.LayerButton, { onClick: function () { return dispatch(actions.addSecondLayer()); }, children: t("layers.add_layer") })) }));
};
